import React from 'react';
//import logo from './logo.svg';
import './App.css';
//import Header from './components/Header/Header';
import Main from './components/Main/Main';
//import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
